import { FC } from 'react';

import styles from './Select.module.css';

type Props = {
  label?: any;
  data: string[];
  onChange: any;
  name: string;
  country?: boolean;
};

export const Select: FC<Props> = ({ name, label, data, onChange, country }) => {
  return (
    <>
      {label && <p style={{ fontSize: '12px' }}>{label}</p>}
      <select name={name} id={name} className={styles.main} onChange={onChange}>
        {country
          ? data.map((el, i) =>
              i === 5 ? (
                <option label="" key={el} value={el}>
                  {el}
                </option>
              ) : (
                <option key={el} value={el}>
                  {el}
                </option>
              ),
            )
          : data.map(el => (
              <option key={el} value={el}>
                {el}
              </option>
            ))}
      </select>
    </>
  );
};
